export const STRUCTURES = [
  {
    name: "Europe",
    link: "https://virtualprogaming.com/news/68ac802c3aca0cdbcb60025f",
  },
  {
    name: "International",
    link: "https://virtualprogaming.com/news/68ac82becfced5b5b1149210",
  },
  {
    name: "VPG Europe",
    link: "https://virtualprogaming.com/news/68acac93cfced5b5b11492c1",
  },
  {
    name: "UK Pro Series",
    link: "https://virtualprogaming.com/news/68acba23cfced5b5b1149343",
  },
];
